<template>
  <section class="flex flex-col mb-14">
    <div class="flex flex-col items-center mb-2">
      <h2 class="checkup-h2">
        Ich bin
      </h2>
      <FieldError
        v-for="error in formErrors.anrede"
        :key="error"
      >
        {{ error }}
      </FieldError>
    </div>

    <OptionGroup
      has-icons
      :options="[
        {value: Anrede.FRAU, label: 'weiblich', icon: 'icomoon/female',
         iconClass: 'gender'},
        {value: Anrede.HERR, label: 'männlich', icon: 'icomoon/male',
         iconClass: 'gender'},
      ]"
      :value="form.anrede"
      option-width-classes="w-1/3 sm:w-1/4 md:w-1/6"
      @change="set('anrede', $event)"
    />

    <div class="flex flex-col items-center gap-5">
      <!-- VORNAME -->
      <div class="w-full sm:w-1/2 md:w-1/3">
        <ElFormItem
          id="formError.vorname"
          label="Vorname"
          for="Vorname"
          :error="formErrors.vorname?.[0]"
          label-position="top"
        >
          <ElInput
            id="Vorname"
            :model-value="form.vorname"
            @update:model-value="set('vorname', $event)"
          />
        </ElFormItem>
      </div>

      <!-- Nachname -->
      <div class="w-full sm:w-1/2 md:w-1/3">
        <ElFormItem
          id="formError.nachname"
          label="Nachname"
          for="Nachname"
          :error="formErrors.nachname?.[0]"
          label-position="top"
        >
          <ElInput
            id="Nachname"
            v-model="form.nachname"
            @update:model-value="() => clear('nachname')"
          />
        </ElFormItem>
      </div>

      <!-- FAMILIENSTAND -->
      <div class="w-full sm:w-1/2 md:w-1/3 mt-8">
        <h2 class="mb-5 checkup-h2">
          Mein Familienstand lautet
        </h2>
        <ElFormItem :error="formErrors.familienstand?.[0]">
          <ElSelect
            id="formError.familienstand"
            v-model="form.familienstand"
            placeholder=""
            required
            @update:model-value="() => clear('familienstand')"
          >
            <ElOption
              v-for="{ label, value } in familienstaende"
              :key="value"
              :label="label"
              :value="value"
            />
          </ElSelect>
        </ElFormItem>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import FieldError from '@/application/components/ui/FieldError.vue';
import { ElFormItem, ElInput, ElOption, ElSelect } from 'element-plus';
import { sortBy } from 'lodash-es';

import OptionGroup from '@/checkup/components/OptionGroup.vue';
import { Anrede, toLabelAndValue } from '@/checkup/utils/demvWerte';
import { demvWerte, useStep } from '@/checkup/state';
import { Step } from '@/checkup/utils/steps';

const { form, formErrors, set, clear } = useStep(Step.GRUNDDATEN);

const familienstaende = sortBy(toLabelAndValue(demvWerte.familienstaende), 'label');
</script>
